import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getMySubscription } from '@/actions/subscription/getMySubscription';
import { ApiResponse } from '@/types/response.type';
import { SubscriptionWithPlan } from '@/types/subscription.type';

interface UseGetMySubscriptionReturn {
  result: ApiResponse<SubscriptionWithPlan> | undefined;
  isLoading: boolean;
  isError: boolean;
}

export const useGetMySubscription = (
  enabled = true
): UseGetMySubscriptionReturn => {
  const query: UseQueryResult<
    ApiResponse<SubscriptionWithPlan>,
    Error
  > = useQuery({
    queryKey: ['my-subscription'],
    queryFn: getMySubscription,
    enabled,
    retry: false,
  });

  return {
    result: query.data,
    isLoading: query.isPending && enabled,
    isError: query.isError,
  };
};
